/*
 * @Author: centerm.gaohan 
 * @Date: 2020-10-12 16:42:49 
 * @Last Modified by: centerm.gaohan
 * @Last Modified time: 2020-11-26 10:58:49
 */

import React, { useEffect, useState } from 'react';
import { Spin } from 'antd';
import { Toast, } from 'antd-mobile';
import invariant from 'invariant';
import { useHistory } from 'react-router-dom'
import { ComponentFormItem, FormItmeType } from '../../../../components/form';
import { api } from '../../../../common/app';
import FormLayout from './compoents/form-layout'
import "./index.css";
import { prefixPath } from './compoents/util';
import FormFooter from './compoents/form-footer';
import { useUserinfo } from './compoents/form-hooks';
import { useUserStatus } from '../../../../common/hooks/user-status';
import moment from 'moment';

function formatDate(date: any) {
  /* eslint no-confusing-arrow: 0 */
  const pad = (n: any) => n < 10 ? `0${n}` : n;
  const dateStr = `${date.getFullYear()}-${pad(date.getMonth() + 1)}-${pad(date.getDate())}`;
  const timeStr = `${pad(date.getHours())}:${pad(date.getMinutes())}`;
  return `${dateStr} ${timeStr}`;
}

export default (props: any) => {
  let params = props.match.params;
  const pathPrefix = prefixPath(props.match.url);
  const history = useHistory();
  const isEdit = window.location.href.indexOf('mine') > -1;

  const { modelstatus, meetindex, datecontrol } = useUserStatus(params.id)
  // 通用formitem属性 
  const [baseFormItemProps, setBaseFormItemProps] = useState({} as any);
  const [baseDeliveryFormItemProps, setBaseDeliveryFormItemProps] = useState({} as any);

  // 是否需要接送机
  const [needPlainPickerData] = useState([{ value: '1', label: '是' }, { value: '0', label: '否' }]);
  const [needPlainSelected, setNeedPlainSelected] = useState('');

  // 接机的类型
  const [plainPickerData] = useState([{ value: '1', label: '火车' }, { value: '2', label: '飞机' }]);
  const [plainSelected, setPlainSelected] = useState('');

  const [addressPickerData, setAddressPickerData] = useState([] as any[]);
  const [addressSelected, setAddressSelected] = useState([] as any[]);

  // 接机时间
  const [checkTime, setCheckTime] = useState('' as any);

  // 站点
  const [trainPickerData, setTrainPickerData] = useState([] as any[]);
  const [trainNumber, setTrainNumber] = useState('');

  // 车次/航班号 上面的写错了
  const [trainTimes, setTrainTimes] = useState('');

  // 是否需要送机
  const [needDeliveryPickerData] = useState([{ value: '1', label: '是' }, { value: '0', label: '否' }]);
  const [needDeliverySelected, setNeedDeliverySelected] = useState('');

  // 送机的类型
  const [deliverySelected, setDeliverySelected] = useState('');

  // 送机地点
  const [addressDeliverySelected, setAddressDeliverySelected] = useState([] as any[]);

  // 送机时间
  const [deliveryTime, setDeliveryTime] = useState('');

  // 送机站点
  const [deliveryPickerData, setDeliveryPickerData] = useState([] as any[]);
  const [deliveryNumber, setDeliveryNumber] = useState('');

  // 车次/航班号 上面的写错了
  const [deliveryTimes, setDeliveryTimes] = useState('');

  // 用户备注
  const [userRemark, setUserRemark] = useState('');

  // 用户送机备注
  const [userDeliveryRemark, setUserDeliveryRemark] = useState('');

  // 用户的接送机数据
  const [myPlain, setMyPlain] = useState({} as any);
  // 
  const [init, setInit] = useState(false);

  const [minDate, setMinDate] = useState(undefined as any);
  const [maxDate, setMaxDate] = useState(undefined as any);
  // 请求最迟和最早的入住时间
  useEffect(() => {
    if (meetindex.start_time && meetindex.end_time) {
      // 修改至0点就可以选择
      const startTime = moment(meetindex.start_time * 1000).subtract(2, 'days');
      const entTime = moment(meetindex.end_time * 1000).add(3, 'days');
      setMinDate(new Date(startTime.year(), startTime.month(), Number(startTime.format('DD')), 0, 0));
      setMaxDate(new Date(entTime.year(), entTime.month(), Number(entTime.format('DD')), 23, 59));
    }
  }, [datecontrol]);

  useEffect(() => {
    window.scrollTo({
      top: 0,
      behavior: 'smooth'
    })
  }, []);

  // 如果是编辑
  useEffect(() => {
    if (params.id && params.formid) {
      (api as any).myPlainInfo({ meetid: params.id, id: params.formid })
        .then((response: any) => {
          console.log('response', response);
          if (response.code === 200) {
            setInit(true);
            const { send_data, join_data, identity } = response.result;
            setMyPlain(response.result);

            // (api as any).getArea()
            //   .then((result: any) => {
            //     setAddressPickerData(result.result);
            //     const joinAddress = [
            //         join_data.province_code,
            //         join_data.city_code,
            //         join_data.area_code,
            //     ].filter((i) => !!i);
            //     console.log("joinAddress", joinAddress);
            //     setAddressSelected(joinAddress);
            //     const sendAddress = [
            //         send_data.province_code,
            //         send_data.city_code,
            //         send_data.area_code,
            //     ].filter((i) => !!i);
            //     console.log("sendAddress", sendAddress);
            //     setAddressDeliverySelected(sendAddress);
                
            //   })
            //   .catch((error: any) => {
            //     Toast.fail(error.message);
            //   });
            setNeedPlainSelected(`${join_data.is_need}`);
            setPlainSelected(`${join_data.type}`);
            setCheckTime(join_data?.give_plain_time ? new Date(join_data?.give_plain_time * 1000) : '');
            setTrainTimes(join_data.give_plain_times);
            setUserRemark(join_data?.remark);

            setNeedDeliverySelected(`${send_data.is_need}`);
            setDeliverySelected(`${send_data.type}`);
            setDeliveryTime(send_data?.give_plain_time ? new Date(send_data?.give_plain_time * 1000) as any : '');
            setDeliveryTimes(send_data.give_plain_times);
            setUserDeliveryRemark(send_data?.remark)

          }
        })
        .catch((err: any) => {
          Toast.fail(err.message || '接口请求失败');
        });
    }
  }, [params]);

  // 编辑初始化的时候赋值
  useEffect(() => {
    if (init && myPlain.join_data && myPlain.send_data) {
      const { join_data, send_data } = myPlain;

      const joinAddress = [
          join_data.province_code,
          join_data.city_code,
          join_data.area_code,
      ].filter((i) => !!i);
      setAddressSelected(joinAddress);
      const sendAddress = [
          send_data.province_code,
          send_data.city_code,
          send_data.area_code,
      ].filter((i) => !!i);
      setAddressDeliverySelected(sendAddress);

      const promises = [];
      const fetchUrl = join_data.type === 1 ? (api as any).getTrain : (api as any).getPlain;
      promises.push(fetchUrl({ city_code: join_data.city_code }));

      const fetchUrl2 = send_data.type === 1 ? (api as any).getTrain : (api as any).getPlain;
      promises.push(fetchUrl2({ city_code: send_data.city_code }));

      Promise.all(promises)
        .then((responses: any[]) => {
          const [result, result1] = responses;
          const pickerData = result.result.length > 0
            ? result.result.map((item: any) => {
              return {
                label: item.name,
                value: item.id
              }
            })
            : [];
          setTrainPickerData(pickerData);
          setTimeout(() => {
            setTrainNumber(join_data?.plain_id);
          }, 1000);

          const pickerData1 = result1.result.length > 0
            ? result1.result.map((item: any) => {
              return {
                label: item.name,
                value: item.id
              }
            })
            : [];
          setDeliveryPickerData(pickerData1);

          setTimeout(() => {
            setDeliveryNumber(send_data?.plain_id);
          }, 1000);
        })
        .finally(() => {
          setTimeout(() => {
            setInit(false);
          }, 500);
        })
    }
  }, [init, myPlain]);

  useEffect(() => {
    // 修改是否需要接机之后调整其他formitem是否可用
    let baseProps: any = {};
    if (needPlainSelected === '0') {
      baseProps.disabled = true;
    } else {
      baseProps.disabled = false;
    }

    if (modelstatus.plain?.status === false) {
      baseProps.disabled = true;
    }
    setBaseFormItemProps(baseProps);
  }, [needPlainSelected, modelstatus]);

  useEffect(() => {
    // 修改是否需要接机之后调整其他formitem是否可用
    let baseProps: any = {};
    if (needDeliverySelected === '0') {
      baseProps.disabled = true;
    } else {
      baseProps.disabled = false;
    }

    if (modelstatus.plain?.status === false) {
      baseProps.disabled = true;
    }
    setBaseDeliveryFormItemProps(baseProps);
  }, [needDeliverySelected, modelstatus])

  // 请求地址
  useEffect(() => {
    (api as any).getArea()
      .then((result: any) => {
        setAddressPickerData(result.result);
      })
      .catch((error: any) => {
        Toast.fail(error.message);
      })
  }, []);

  /**
   * 修改接机类型要重新选择车次、航班号
   * 修改地址要重新选择车次或者航班号
   */
  useEffect(() => {

    if (init) {
      return;
    }
    setTrainNumber('');

    if (!plainSelected) {
      return;
    }

    const fetchUrl = plainSelected === '1' ? (api as any).getTrain : (api as any).getPlain;
    const cityCode = addressSelected.length === 3 ? addressSelected[1] : addressSelected[addressSelected.length - 1];
    fetchUrl({ city_code: cityCode })
      .then((result: any) => {
        const pickerData = result.result.length > 0
          ? result.result.map((item: any) => {
            return {
              label: item.name,
              value: item.id
            }
          })
          : [];
        setTrainPickerData(pickerData);
      })
      .catch((error: any) => {
        Toast.fail(error.message);
      })
  }, [addressSelected, plainSelected, init]);


  /**
   * 修改送机类型要重新选择车次、航班号
   * 修改送机地址要重新选择车次或者航班号
   */
  useEffect(() => {

    if (init) {
      return;
    }

    setDeliveryNumber('');

    if (!deliverySelected) {
      return;
    }

    const fetchUrl = deliverySelected === '1' ? (api as any).getTrain : (api as any).getPlain;
    const cityCode = addressDeliverySelected.length === 3 ? addressDeliverySelected[1] : addressDeliverySelected[addressDeliverySelected.length - 1];
    fetchUrl({ city_code: cityCode })
      .then((result: any) => {
        const pickerData = result.result.length > 0
          ? result.result.map((item: any) => {
            return {
              label: item.name,
              value: item.id
            }
          })
          : [];
        setDeliveryPickerData(pickerData);
      })
      .catch((error: any) => {
        Toast.fail(error.message);
      })
  }, [addressDeliverySelected, deliverySelected, init]);

  const onChangeValue = (value: any, callback: (params: any) => void) => {
    callback(value);
  }

  /**
   * 跳过设置
   */
  const onSkip = () => {
    const meetid = params.id;
    (api as any)
      .getPayData({ meetid: params.id })
      .then((result: any) => {
        console.log("result", result);
        if (
            !isEdit && 
            result.result.pay_type !== 1 &&
            result.result.is_pay !== true
        ) {
            history.replace(`/home/pay/${params.id}`);
            return;
        } else {
          history.replace(`/${pathPrefix}/index/${meetid}`);
        }
      });
  }

  /**
   * 用户点击填好之后触发验证然后调接口
   * 
   */
  const onSubmit = async () => {
    try {
      invariant(!!needPlainSelected, '请选择是否需要接机');

      // 需要接机
      if (needPlainSelected === '1') {
        invariant(!!plainSelected, '请选择接机类型');
        invariant(!!addressSelected, '请选择接机地址');
        invariant(!!checkTime, '请选择接机时间');
        invariant(!!trainNumber, '请选择接机站点');
        invariant(!!trainTimes, '请选择接机车次/航班号');
      }

      invariant(!!needDeliverySelected, '请选择是否需要送机');
      // 需要送机
      if (needDeliverySelected === '1') {
        invariant(!!deliverySelected, '请选择送机类型');
        invariant(!!addressDeliverySelected, '请选择送机地址');
        invariant(!!deliveryTime, '请选择送机时间');
        invariant(!!deliveryNumber, '请选择送机站点');
        invariant(!!deliveryTimes, '请输入送机车次/航班号');
      }

      const isMine = window.location.href.indexOf('/mine/') > -1;
      const isEdit = !!params.formid;
      // 通用属性
      const payloadBase = {
        meetid: params.id,
      }
      const payloadPlain = {
        ...payloadBase,
        // 1接2送
        give_type: 1,
        // 是否需要接送机
        is_need: needPlainSelected,
        ...isEdit ? { id: myPlain.join_data.id } : {},
        ...needPlainSelected === '1'
          ? {
            // 接机的类型
            type: plainSelected,
            // 接机时间
            choice_time: !!checkTime && Math.ceil(checkTime.getTime() / 1000),
            // 车次、航班号
            times: trainTimes,
            // 用户备注
            remark: userRemark,
            // 站点
            plain_id: trainNumber,

            // 省市区code
            province_code: addressSelected[0],
            city_code: addressSelected[1],
            area_code: addressSelected[2] || 0,
          }
          : {}
      }

      const payloadDelivery = {
        ...payloadBase,
        // 1接2送
        give_type: 2,
        // 是否需要送机
        is_need: needDeliverySelected,
        ...isEdit ? { id: myPlain.send_data.id } : {},
        ...needDeliverySelected === '1'
          ? {
            // 送机的类型
            type: deliverySelected,
            // 送机时间
            choice_time: !!deliveryTime && Math.ceil((deliveryTime as any).getTime() / 1000),
            // 送机车次/航班号
            times: deliveryTimes,
            // 用户送机备注
            remark: userDeliveryRemark,
            // 送机地址
            plain_id: deliveryNumber,

            // 省市区code
            province_code: addressDeliverySelected[0],
            city_code: addressDeliverySelected[1],
            area_code: addressDeliverySelected[2] || 0,
          }
          : {}
      }

      console.log('payloadPlain', payloadPlain);
      console.log('payloadDelivery', payloadDelivery);

      // return;
      // 接送机的promises
      const promises = [
        (api as any).choiceGivePlain(payloadPlain),
        (api as any).choiceGivePlain(payloadDelivery),
      ];

      Promise.all(promises)
        .then((result) => {
          const resultPlain = result[0];
          const resultDelivery = result[1];
          if (resultPlain.code !== 200) {
            Toast.fail(resultPlain.message);
            return;
          }
          if (resultDelivery.code !== 200) {
            Toast.fail(resultDelivery.message);
            return;
          }
          Toast.success('更新成功！', 1);

          setTimeout(() => {

            // 成功之后跳转
            if (isMine) {
              history.goBack();
              return;
            }
            //!isEdit
            (api as any)
                .getPayData({ meetid: params.id })
                .then((result: any) => {
                  console.log("result", result);
                  if (
                        !isEdit && 
                        result.result.pay_type !== 1 &&
                        result.result.is_pay !== true
                    ) {
                        history.replace(`/home/pay/${params.id}`);
                        return;
                    } else {
                      const meetid = params.id;
                      (api as any)
                          .showButton({ meetid })
                          .then((result: any) => {
                              console.log("result", result);
                              if (result.code !== 200) {
                                  return;
                              }
                              history.replace(`/${pathPrefix}/index/${meetid}`);
                          })
                          .catch((err: any) => {
                              console.log("err", err);
                          });
                    }
                });
          }, 1000);
        }).catch((error) => {
          Toast.fail(error.message, 1);
        });
    } catch (error) {
      Toast.fail(error.message, 1);
    }
  }
  return (
    <FormLayout>
      <Spin spinning={init}>
        <div className='form-register-title'>填写接机</div>
        <ComponentFormItem
          formTitle='是否需要接机'
          cols={1}
          formType={FormItmeType.Picker}
          data={needPlainPickerData}
          value={[needPlainSelected]}
          onOk={(params) => onChangeValue(params[0], setNeedPlainSelected)}
          disabled={modelstatus.plain?.status === false}
        />
        <ComponentFormItem
          formTitle='接机/接车类型'
          cols={1}
          formType={FormItmeType.Picker}
          data={plainPickerData}
          value={[plainSelected]}
          onOk={(params) => onChangeValue(params[0], setPlainSelected)}
          {...baseFormItemProps}
        />
        <ComponentFormItem
          formTitle='城市'
          formType={FormItmeType.Picker}
          data={addressPickerData}
          value={addressSelected}
          cols={2}
          onOk={(params) => onChangeValue(params, setAddressSelected)}
          {...baseFormItemProps}
        />
        <ComponentFormItem
          formTitle='日期'
          // mode='date'
          formType={FormItmeType.DatePicker}
          value={checkTime}
          onOk={(params: any) => onChangeValue(params, setCheckTime)}
          {...minDate !== undefined ? { minDate: minDate } : {}}
          {...maxDate !== undefined ? { maxDate: maxDate } : {}}
          {...baseFormItemProps}
        />
        <ComponentFormItem
          cols={1}
          formTitle='站点'
          formType={FormItmeType.Picker}
          data={trainPickerData}
          value={[trainNumber]}
          onOk={(params) => onChangeValue(params[0], setTrainNumber)}
          {...baseFormItemProps}
        />
        <ComponentFormItem
          formTitle='车次/航班号'
          placeholder='车次/航班号'
          formType={FormItmeType.Input}
          value={trainTimes}
          onChange={(e: any) => setTrainTimes(e.target.value)}
          {...baseFormItemProps}
        />
        <ComponentFormItem
          formTitle='备注信息'
          formType={FormItmeType.Input}
          placeholder='备注信息'
          value={userRemark}
          maxLength={50}
          onChange={(e: any) => setUserRemark(e.target.value)}
          {...baseFormItemProps}
        />

        <div className='form-register-title'>填写送机</div>

        <ComponentFormItem
          formTitle='是否需要送机'
          cols={1}
          formType={FormItmeType.Picker}
          data={needDeliveryPickerData}
          value={[needDeliverySelected]}
          onOk={(params) => onChangeValue(params[0], setNeedDeliverySelected)}
          disabled={modelstatus.plain?.status === false}
        />

        <ComponentFormItem
          formTitle='送机/送机类型'
          cols={1}
          formType={FormItmeType.Picker}
          data={plainPickerData}
          value={[deliverySelected]}
          onOk={(params) => onChangeValue(params[0], setDeliverySelected)}
          {...baseDeliveryFormItemProps}
        />

        <ComponentFormItem
          formTitle='城市'
          cols={2}
          formType={FormItmeType.Picker}
          data={addressPickerData}
          value={addressDeliverySelected}
          onOk={(params) => onChangeValue(params, setAddressDeliverySelected)}
          {...baseDeliveryFormItemProps}
        />

        <ComponentFormItem
          formTitle='日期'
          // mode='date'
          formType={FormItmeType.DatePicker}
          value={deliveryTime as any}
          extra={deliveryTime && formatDate(deliveryTime)}
          onChange={(params: any) => onChangeValue(params, setDeliveryTime)}
          {...minDate !== undefined ? { minDate: minDate } : {}}
          {...maxDate !== undefined ? { maxDate: maxDate } : {}}
          {...baseDeliveryFormItemProps}
        />

        <ComponentFormItem
          cols={1}
          formTitle='站点'
          formType={FormItmeType.Picker}
          data={deliveryPickerData}
          value={[deliveryNumber]}
          onOk={(params) => onChangeValue(params[0], setDeliveryNumber)}
          {...baseDeliveryFormItemProps}
        />

        <ComponentFormItem
          formTitle='车次/航班号'
          placeholder='车次/航班号'
          formType={FormItmeType.Input}
          value={deliveryTimes}
          onChange={(e: any) => setDeliveryTimes(e.target.value)}
          {...baseDeliveryFormItemProps}
        />

        <ComponentFormItem
          formTitle='备注信息'
          formType={FormItmeType.Input}
          placeholder='备注信息'
          maxLength={50}
          value={userDeliveryRemark}
          onChange={(e: any) => setUserDeliveryRemark(e.target.value)}
          {...baseDeliveryFormItemProps}
        />
        <FormFooter
          meetid={params.id}
          type='plain'
          isEdit={isEdit}
          onSkip={onSkip}
          onSubmit={onSubmit}
        />
      </Spin>
    </FormLayout>
  )
}